import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2073eeda")

_pushScopeId("data-v-2073eeda")
const _hoisted_1 = { class: "InvoiceHeader" }
const _hoisted_2 = { class: "InvoiceHeader__information" }
const _hoisted_3 = { class: "information__footer" }
const _hoisted_4 = {
  key: 0,
  class: "information__title"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" [Возврат] ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_bread_crumbs = _resolveComponent("s-bread-crumbs")!
  const _component_icon_arrow_left = _resolveComponent("icon-arrow-left")!
  const _component_invoice_header_actions = _resolveComponent("invoice-header-actions")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_s_bread_crumbs, { links: _ctx.breadcrumbsLinks }, null, 8, ["links"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_icon_arrow_left, {
          class: "information__back",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
        }),
        (_ctx.invoiceState.data)
          ? (_openBlock(), _createBlock("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.invoiceState.data.invoice_number) + " ", 1),
              (_ctx.isReturn)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_5
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_invoice_header_actions)
  ]))
})